import p from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { useWindowWidth } from '@exchange-frontends/custom-hooks';

/**
 * Component for clamping elements to a certain number of lines. It's using the x height + a constant as the character width
 */
const WithEllipsis = (props) => {
  const { lines = 1, children } = props;
  const elementRef = useRef();
  const [initialValue, setInitalValue] = useState(null);
  const [letterWidth, setLetterWidth] = useState(null);
  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (initialValue) {
      elementRef.current.innerText = initialValue;
      const lineHeight = parseInt(window.getComputedStyle(elementRef.current).lineHeight);
      const height = elementRef.current.clientHeight;
      const width = elementRef.current.clientWidth;
      const currentLines = height / lineHeight;
      if (currentLines > lines) {
        const charatersPerLine = width / (letterWidth + 1.5);
        elementRef.current.innerText = initialValue.slice(0, lines * charatersPerLine).trim() + '...';
      }
    }
  }, [windowWidth, initialValue, letterWidth]);

  useEffect(() => {
    if (initialValue === null) {
      setInitalValue(elementRef.current?.innerText);
    }
    if (letterWidth === null) {
      const originalWidth = elementRef.current.style.width;
      elementRef.current.style.width = '1ex'; // this is x height, usually a good average width of the letters
      setLetterWidth(parseInt(getComputedStyle(elementRef.current).width));
      elementRef.current.style.width = originalWidth ?? '';
    }
  }, []);

  return React.cloneElement(children, { ref: elementRef });
};

WithEllipsis.propTypes = {
  /** The number of lines that you want the element to be clamped to (default: 1). */
  lines: p.number,
  /** The respective element. It must be an element, not just text. */
  children: p.element,
};

WithEllipsis.defaultProps = {
  lines: 1,
};

export default WithEllipsis;
